import { CreditCard, FantazUIError } from '@fantaz/shared/data-access/models';
import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from '@ngrx/store';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~ Verify User With Credit Card Dialog Actions
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const VerifyUserWithCreditCardDialogActions = createActionGroup({
  source: '[RegisterCreditCard Dialog]',
  events: {
    open: props<{ creditCard?: CreditCard }>(),
  },
});

export const openRegisterCreditCardDialog = createAction(
  '[RegisterCreditCard Page] Init',
  props<{ creditCard?: CreditCard }>(),
);

export const openRegisterCreditCardFailureDialog = createAction(
  '[RegisterCreditCard Page] Open Register Credit Card Failure Dialog',
  props<{ error: FantazUIError }>(),
);
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~ Verify User With Credit Card Api Actions
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const VerifyUserWithCreditDialogActions = createActionGroup({
  source: '[RegisterCreditCard/API]',
  events: {
    verify: props<{ creditCard: CreditCard }>(),
    verifySuccess: emptyProps(),
    verifyFailure: (error: FantazUIError) => ({ error }),
  },
});

export const VerifyUserWithCreditActions = createActionGroup({
  source: '[VerifyCreditCard/API]',
  events: {
    // update user profile
    'Save User Profile': props<{ creditCard: CreditCard }>(),
    'Save User Profile Success': props<{ creditCard: CreditCard }>(),
    'Save User Profile Failure': props<{
      error: any;
      creditCard?: CreditCard;
    }>(),

    // kyc
    'Verify Credit Card': props<{ creditCard: CreditCard }>(),
    'Verify Credit Card Success': props<{ creditCard: CreditCard }>(),
    'Verify Credit Card Failure': props<{
      error: any;
      creditCard?: CreditCard;
    }>(),
  },
});

export const verifyUserWithCreditCard = createAction(
  '[VerifyCreditCard/API] Verify User With Credit Card',
  props<{ creditCard: CreditCard }>(),
);

export const verifyUserWithCreditCardSuccess = createAction(
  '[VerifyCreditCard/API] Verify User With Credit Card Success',
);

export const verifyUserWithCreditCardFailure = createAction(
  '[VerifyCreditCard/API] Verify User With Credit Card Failure',
  props<{ error: FantazUIError }>(),
);
